import { HttpClinet, baseURL, version } from "./../utils/config";

export const mindayAPI = {
  getBGroupItec: () => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/minday/getBGroupItec`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getAllBrandItec: () => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/minday/getAllBrandItec`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getAllCategoryItec: () => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/minday/getAllCategoryItec`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getAllModelItec: (params) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/minday/getAllModelItec`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getAllSubCategoryItec: (params) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/minday/getAllSubCategoryItec`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      params,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getMinDay: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/minday/getMinDay`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  downloadMinDay: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/minday/downloadMinDay`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      responseType: "blob",
      data,
    })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  },
};
